import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../services/jrni/services.service';
import { DepartmentService } from '../services/jrni/department.service';
import { AvailabilityService } from '../services/jrni/availability.service';
import { DatastoreService } from '../services/datastore.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../app.config';
import { ApiService } from '../services/jrni/api.service';

@Component({
  selector: 'app-booking-summary',
  templateUrl: './booking-summary.component.html',
  styleUrls: ['./booking-summary.component.scss'],
})
export class BookingSummaryComponent implements OnInit {
  selectedService;
  selectedLocation;
  selectedResource;
  selectedSlot;
  selectedDepartment;
  address;
  endSlot;
  currentLang: string;
  citizenshipJourney = false;
  resourceLocation: string;
  resourcedAddress: any;
  addressOverride: string[] | null = null;

  constructor(
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private availabilityService: AvailabilityService,
    private datastoreService: DatastoreService,
    public translateService: TranslateService,
    private apiService: ApiService,
  ) { }

  async ngOnInit() {
    this.currentLang = this.translateService.store.currentLang;

    let configCompanyId = AppConfig.settings.core.company_id;

    if (this.datastoreService.isCitizenshipRoute) {
      this.citizenshipJourney = true;
      configCompanyId = AppConfig.settings.core.citizenship_company_id;
    }

    const _config: any = await this.apiService.getConfig(configCompanyId);
    this.resourceLocation = _config.journey_config.appointments.general.resourceAddressEnabled;
    console.log('Resource Location Enabled: ', this.resourceLocation);

    if (this.resourceLocation) {
      this.resourcedAddress = this.datastoreService.selectedResource.extra.resource_address;
      console.log('Resourced Address: ', this.resourcedAddress);
    }

    // Some services are held somewhere other than the location the customer picked, so
    // service_address_overrides names the address to show for them instead.
    const addressOverrides =
      _config.base_config.general.service_address_overrides || {};

    // Get the selected service
    this.servicesService.get().then((service) => {
      this.selectedService = service;
      this.addressOverride =
        addressOverrides[service?.global_id] || addressOverrides[service?.id] || null;
    });

    // Get the selected location
    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.getLocation().then((location) => {
      this.selectedLocation = location;
    });

    this.availabilityService.getSelectedResourceObj().then((resource) => {
      if (resource) {
        this.selectedResource = resource;
      }
    });

    // Get the selected address
    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.getLocation().then((res) => {
      this.address = res;
    });


    // Get the selected slot and end of slot
    this.availabilityService.getSelectedSlot().then((slot) => {
      this.selectedSlot = slot;
    });
    this.availabilityService.getEndSlot().then((slot) => {
      this.endSlot = slot;
      this.datastoreService.selectedSlot = slot;
    });
  }
}
